import React from 'react';
import Layout from 'layout/Layout';
import WorkshopPost from './Workshop subsections/WorkshopPost';
import WorkshopIsThisYou from './Workshop subsections/WorkshopIsThisYou';
import WorkshopWhyJoinThis from './Workshop subsections/WorkshopWhyJoinThis';
import WhatYouLearn from './Workshop subsections/WhatYouLearn';
import WhoIsThisFor from './Workshop subsections/WhoIsThisFor';
import FaqSection from './Workshop subsections/FaqSection';

const WorkshopDetails = () => {
    return (
        <Layout title="Workshop Details" tagline="Explore detailed information.">
            <WorkshopPost />
            <WorkshopIsThisYou />
            <WorkshopWhyJoinThis />
            <WhatYouLearn />
            <WhoIsThisFor />
            <FaqSection />
        </Layout>
    );
};

export default WorkshopDetails;
